import { GET_DISPUTED_TRANSACTIONS_REPORT } from '../../../Types'

const DisputedTransactionsReportReducer = (state = [], action) => {
    switch (action.type) {
        case GET_DISPUTED_TRANSACTIONS_REPORT:
          return action.payload
        default:
            return state
    }
}
export default DisputedTransactionsReportReducer 